export default "__VITE_ASSET__CIivrkVK__"